import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import * as yup from "yup";

export interface ILogPrinterFormMeta {
  logPrinterState: FormInputMeta;
  logPrinterPrinter: FormInputMeta;
  logPrinterPaper: FormInputMeta;
  logPrinterRibbon: FormInputMeta;
  logPrinterHead: FormInputMeta;

}

const logPrinterFormMeta = {} as ILogPrinterFormMeta;

logPrinterFormMeta.logPrinterState = {
    name: "logPrinterState",
    type: "select",
    label: "Etat",
    validation: yup.string().required("Champ obligatoire !"),
};

logPrinterFormMeta.logPrinterPrinter = {
    name: "logPrinterPrinter",
    type: "select",
    label: "Imprimante",
    validation: yup.string().required("Champ obligatoire !"),
};

logPrinterFormMeta.logPrinterPaper = {
    name: "logPrinterPaper",
    type: "select",
    label: "Papier",
    validation: yup.string().required("Champ obligatoire !"),
};

logPrinterFormMeta.logPrinterRibbon = {
    name: "logPrinterRibbon",
    type: "select",
    label: "Ribbon",
    validation: yup.string().required("Champ obligatoire !"),
};

logPrinterFormMeta.logPrinterHead = {
    name: "logPrinterHead",
    type: "select",
    label: "Tête",
    validation: yup.string().required("Champ obligatoire !"),
};

export default logPrinterFormMeta;